/**
 * Toast copy for local thread lifecycle actions (close / reopen / mark read).
 * Uses the shared @aimsos/ui ToastProvider — top-right success toast with
 * title + message (same pattern as HITL / task decisions).
 */

export function threadClosedToast(t) {
  return {
    title: t('thread.closedTitle'),
    message: t('thread.closedMessage'),
  };
}

export function threadReopenedToast(t) {
  return {
    title: t('thread.reopenedTitle'),
    message: t('thread.reopenedMessage'),
  };
}

export function questionMarkedReadToast(t) {
  return {
    title: t('question.markedReadTitle'),
    message: t('question.markedReadMessage'),
  };
}
